import { SVGProps } from 'react';

const MailX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9m9-13-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7m15 10 4 4m0-4-4 4"
    />
  </svg>
);
export default MailX;
